import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'

/**
 * 品牌邀请门店加入（云端会员后台发出，门店在这里接受 / 拒绝）。
 * 这三个接口按设备号认门店，不需要登录。
 *
 * 不用 hillo：hillo 遇到 4xx 会吞掉响应、只弹通用错误，后端给的原因（比如「本店已加入其他品牌」）就看不到了。
 */
const path = cloudV2Url + 'member-admin/public/shop-invites'

async function request (url, options = {}) {
  const res = await fetch(url, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) }
  })
  let body = null
  try {
    body = await res.json()
  } catch (e) {
    // 非 JSON 响应按状态码处理
  }
  if (!res.ok || (body && body.code && body.code !== 200)) {
    throw new Error(body?.message || `HTTP ${res.status}`)
  }
  return body?.data
}

/** 本店收到的、还没处理的邀请，每条带「加入后会停用什么」 */
export async function getReceivedShopInvites (deviceId) {
  return (await request(`${path}?deviceId=${encodeURIComponent(deviceId)}`)) ?? []
}

export async function acceptShopInvite (inviteId, deviceId) {
  return request(`${path}/${inviteId}/accept`, {
    method: 'POST',
    body: JSON.stringify({ deviceId: Number(deviceId) })
  })
}

export async function rejectShopInvite (inviteId, deviceId) {
  return request(`${path}/${inviteId}/reject`, {
    method: 'POST',
    body: JSON.stringify({ deviceId: Number(deviceId) })
  })
}
